import { Controller } from "@hotwired/stimulus"

// Champ sensible : masqué par défaut, affiché à la demande.
export default class extends Controller {
  static targets = ["mask", "value"]

  toggle(event) {
    const hidden = this.valueTarget.hidden
    this.valueTarget.hidden = !hidden
    this.maskTarget.hidden = hidden
    event.currentTarget.textContent = hidden ? "Masquer" : "Afficher"
  }
}
